import React from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {Form, message, Upload} from "antd";
import {CloseOutlined} from "@ant-design/icons";
import uploadIcon from '../../../../../assets/icons/page/entrant/admission/icon_upload.svg'

export const AdmissionUploadComponent = ({title, name, required}:any) => {
  const { t } = useTranslation('executorAdmissionSteps');

  const formatCheck = (file:any) => {
    const fileSizeInMB = file.size / 1024 / 1024;

    if (fileSizeInMB > 100) {
      message.error("Файл должен быть меньше 100 мегабайт")
      return Upload.LIST_IGNORE;
    }
    if (file.type !== 'image/png' || file.type !== 'image/jpeg' || file.type !== 'application/pdf' || file.type !== 'image/jpg') {
    }
    return file.type === 'image/png' ? true : file.type === 'image/jpeg' ? true : file.type === 'application/pdf' ? true : file.type === 'image/jpg' ? true : Upload.LIST_IGNORE;
  }

  const normFile = (e:any) => {

    if (Array.isArray(e)) {
      return e;
    }

    // if (e.fileList.length > 1){
    //   e.fileList.shift();
    // }

    return e && e.fileList;
  };

  const createDoc = async (options:any) => {
    const {file, onSuccess, onProgress, onError} = options
    const config = {
      headers: {"content-type": "multipart/form-data"},
      onUploadProgress: (e:any) => {
        const percent = Math.floor((e.loaded / e.total) * 100)

        onProgress({percent: percent})
      }
    }

    const setFileType = (fileType:any) => {
      const steps = {
        'application/pdf': '.pdf',
        'image/jpeg': '.jpeg',
        'image/jpg': '.jpg',
        'image/png': '.png',
      }

      // @ts-ignore
      return steps[fileType]
    }

    const name = (title + setFileType(file.type))

    const formData = new FormData;
    formData.append('yModel', 'Upload');
    formData.append('Upload[name]', name)
    formData.append('Upload[file]', file)


    try{
      const res = await axios.post('https://s3.sdot.kz/upload', formData, config)

      onSuccess(res);
    } catch (e) {
      console.log("Error: ", e);
      const error = new Error("Some error");
      onError({ e });
    }

  }

  return (
    <Form.Item
      name={name}
      label={t(`${title}`)}
      valuePropName="fileList"
      getValueFromEvent={normFile}
      extra={t("stepFour.supportedFileTypes")}
      rules={[{ required: required, message: 'Необходимо загрузить документ' }]}
    >
        <Upload
          beforeUpload={(file, fileList) => formatCheck(file)}
          showUploadList={{
            removeIcon: <CloseOutlined/>,
            showDownloadIcon: false
          }}
          name={name}
          maxCount={5}
          multiple
          customRequest={createDoc}
          progress={{strokeWidth: 5, showInfo: false}}
        >
          <img src={uploadIcon} alt="" width={48} height={48}/>
        </Upload>
    </Form.Item>
  )
}

